<div
  class="relative w-full h-full pt-2 px-2 pb-12 flex flex-col gap-2 lg:gap-6 bg-gray-100 dark:bg-gray-800 overflow-y-auto overflow-x-hidden"
  #messageField
>
  @for (messageData of messageBox; track messageData) {
    <div
      class="bubble"
      [ngClass]="{ right: messageData.type == 'user', left: messageData.type == 'ai' }"
      [innerHTML]="messageData.message"
    ></div>
  }
  @if (isLoading) {
    <div class="bubble left">
      <div class="flex flex-row gap-1.5 px-2 py-0.5">
        <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse-1"></div>
        <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse-2"></div>
        <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse-3"></div>
      </div>
    </div>
  }
</div>
<!-- <div
  class="relative px-2 pt-1 lg:px-4 w-full overflow-x-auto overflow-y-hidden flex flex-row flex-nowrap gap-2 flex-none bg-black"
>
  @for (autoPrompt of autoPrompts; track autoPrompt) {
    <button
      class="flex-none rounded-full bg-sky-600 px-2 py-1 text-white text-[10px] lg:text-sm max-w-[40%] lg:max-w-[45%] overflow-hidden text-nowrap text-ellipsis disabled:bg-gray-300"
      [disabled]="isLoading"
      (click)="prompt(autoPrompt.prompt, inputField, autoPrompt.next)"
    >
      {{ autoPrompt.prompt }}
    </button>
  }
</div> -->

<div
  class="relative flex justify-center items-center w-full h-10 lg:h-14 px-2 lg:px-4 flex-none bg-[#acacac] dark:bg-black"
>
  <form
    class="relative w-full flex flex-row gap-2 items-center px-2 lg:px-4 py-0.5 lg:py-1 rounded-full shadow-inner"
    [ngClass]="{ 'bg-white': !isLoading, 'bg-gray-200': isLoading }"
  >
    <input
      type="text"
      class="w-full text-[10px] lg:text-base outline-none"
      [ngClass]="{ 'bg-gray-200 text-black/40': isLoading, 'bg-white text-black': !isLoading }"
      placeholder="Send to message..."
      [formControl]="userInput"
      [disabled]="isLoading"
      #inputField
    />
    <button
      class="rounded-lg flex justify-center items-center h-6 lg:h-8 w-8 lg:w-10 p-1.5 lg:p-2 bg-black hover:bg-gray-800 disabled:bg-black/40 text-white"
      [disabled]="isLoading"
      (click)="sendMessage(inputField)"
    >
      <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
          d="M10.5004 11.9998H5.00043M4.91577 12.2913L2.58085 19.266C2.39742 19.8139 2.3057 20.0879 2.37152 20.2566C2.42868 20.4031 2.55144 20.5142 2.70292 20.5565C2.87736 20.6052 3.14083 20.4866 3.66776 20.2495L20.3792 12.7293C20.8936 12.4979 21.1507 12.3822 21.2302 12.2214C21.2993 12.0817 21.2993 11.9179 21.2302 11.7782C21.1507 11.6174 20.8936 11.5017 20.3792 11.2703L3.66193 3.74751C3.13659 3.51111 2.87392 3.39291 2.69966 3.4414C2.54832 3.48351 2.42556 3.59429 2.36821 3.74054C2.30216 3.90893 2.3929 4.18231 2.57437 4.72906L4.91642 11.7853C4.94759 11.8792 4.96317 11.9262 4.96933 11.9742C4.97479 12.0168 4.97473 12.0599 4.96916 12.1025C4.96289 12.1506 4.94718 12.1975 4.91577 12.2913Z"
          stroke="#ffffff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </form>
</div>
